<template>
  <div class="foot">
    <div class="about-us-title">
      <img src="@/assets/home-17.png" class="home-17">
    </div>
    <div class="about-list">
      <div class="foot-logo"> <img src="@/assets/foot-1.png" class="foot-1"></div>
      <div class="font-hz"><img src="@/assets/foot-3.png" class="foot-3"> <span>商务合作：permadi@@wavetec-globe.com </span> </div>
      <div class="font-jz"><img src="@/assets/foot-2.png" class="foot-2"><span>简历投递：career@wavetec-globe.com</span></div>
    </div>
    <div class="foot-s">
      <img src="@/assets/foot-4.png" class="foot-4">
      <img src="@/assets/foot-4.png" class="foot-4">
      <img src="@/assets/foot-4.png" class="foot-4">
      <img src="@/assets/foot-4.png" class="foot-4">
    </div>
    <div class="foot-menu-box">
      <div @click="onFirestorm(0)" :class="(menuIndex===0)?'menuIndex':''">Firestorm简介</div>
      <div @click="onFirestorm(1)" :class="(menuIndex===1)?'menuIndex':''">产品与团队</div>
      <div @click="onFirestorm(2)" :class="(menuIndex===2)?'menuIndex':''">加入我们</div>
      <div @click="onFirestorm(3)" :class="(menuIndex===3)?'menuIndex':''">联系我们</div>
    </div>

    <div class="foot-ls">
      <span>粤ICP备2021026394号 ｜ </span>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502007316">
        <span class="foot-ls"> 粤公网安备 44030502007316号</span>
      </a>
    </div>

  </div>
</template>
<script>
export default {
  name: "foot",
  props: {
    menuIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      index: 0
    }
  },
  mounted () {

  },
  methods: {
    onFirestorm (value) {
      switch (value) {
        case 0:
          this.$router.push({ path: '/' })
          break;
        case 1:
          this.$router.push({ path: '/team' })
          break;
        case 2:
          this.$router.push({ path: '/welfare' })
          break;
        case 3:
          this.$router.push({ path: '/about' })
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      })
    },
  }
};
</script>

<style lang="less" scoped>
@minwidth: 768px;
.foot {
  background: #3f3f3f;
  min-height: 360px;
  overflow: hidden;
  .home-17 {
    width: 83px;
    @media screen and (max-width: @minwidth) {
      width: 249px;
    }
  }
  .about-us-title {
    font-style: oblique;
    font-size: 18px;
    color: #ffffff;
    margin-top: 48px;
    text-align: center;
  }
  .about-list {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #ffffff;
    padding: 0px 270px;
    margin-top: 51px;
    align-items: center;
    .foot-logo {
      @media screen and (max-width: @minwidth) {
        display: none;
        width: 0px;
      }
    }
    .foot-1 {
      width: 189px;
      margin-top: -13px;
    }
    .foot-2 {
      width: 20px;
      margin-right: 10px;
      @media screen and (max-width: @minwidth) {
        width: 40px;
      }
    }
    .foot-3 {
      width: 20px;
      margin-right: 10px;
      @media screen and (max-width: @minwidth) {
        width: 40px;
      }
    }
    .font-hz,
    .font-jz {
      display: flex;
      align-items: center;
    }
  }
  .foot-s {
    margin: 0px 210px;
    margin-top: 54px;
    display: flex;
    align-items: centers;
    overflow: hidden;
    .foot-4 {
      width: 400px;
      height: 2px;
    }
  }
  .foot-menu-box {
    display: flex;
    padding: 0px 675px;
    margin-top: 64px;
    justify-content: space-between;
    font-size: 16px;
    color: #ffffff;
    @media screen and (max-width: @minwidth) {
      padding: 0px 65px;
      margin-bottom: 100px;
    }
    div {
      cursor: pointer;
    }
  }
  .foot-ls {
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-top: 37px;
    margin-bottom: 20px;
  }
  .menuIndex {
    color: #ffa317;
  }
}
</style>